// API Configuration

// Helper function to safely access process.env
const getEnvVar = (key, fallback) => {
  try {
    return (typeof process !== 'undefined' && process.env && process.env[key]) || fallback;
  } catch (e) {
    return fallback;
  }
};

// Helper function to ensure HTTPS in production
export const ensureHttps = (url) => {
  if (!url) return url;
  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && url.startsWith('http://')) {
    const httpsUrl = url.replace('http://', 'https://');
    console.log(`[API Config] Converted to HTTPS: ${url} → ${httpsUrl}`);
    return httpsUrl;
  }
  return url;
};

// Base API URLs with environment variable fallbacks
export const API_BASE_URL = ensureHttps(getEnvVar('REACT_APP_CUSTOMER_SERVICE_URL', 'http://localhost:8087'));
export const MAP_SERVICE_URL = ensureHttps(getEnvVar('REACT_APP_MAP_MANAGEMENT_URL', 'http://localhost:8094'));
export const VEHICLE_SERVICE_URL = ensureHttps(getEnvVar('REACT_APP_VEHICLE_SERVICE_URL', 'http://localhost:8083'));
export const ACTOR_SERVICE_URL = ensureHttps(getEnvVar('REACT_APP_ACTOR_SERVICE_URL', 'http://localhost:8081'));

// Default request timeout in milliseconds
export const API_TIMEOUT = 30000;

// Default headers for API requests
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};

// Helper function to get the appropriate base URL for a service
export const getApiBaseUrl = (service) => {
  switch (service.toLowerCase()) {
    case 'map':
      return MAP_SERVICE_URL;
    case 'vehicle':
      return VEHICLE_SERVICE_URL;
    case 'actor':
      return ACTOR_SERVICE_URL;
    case 'customer':
    default:
      return API_BASE_URL;
  }
};

// Export unified API config for consumption by other modules
export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  MAP_SERVICE_URL: MAP_SERVICE_URL,
  VEHICLE_SERVICE_URL: VEHICLE_SERVICE_URL,
  ACTOR_SERVICE_URL: ACTOR_SERVICE_URL,
  CUSTOMER_SERVICE_URL: API_BASE_URL,
  TIMEOUT: API_TIMEOUT,
  HEADERS: DEFAULT_HEADERS,
  getBaseUrl: getApiBaseUrl,
  
  // Image paths
  getImageUrl: (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    
    // Handle file paths consistently
    let formattedPath = path;
    const timestamp = new Date().getTime();  // Add cache-busting timestamp
    
    // Critical fix for existing database records: 
    // Convert '/static/uploads/photos/...' to '/uploads/photos/...'
    if (path.includes('/static/uploads/photos/')) {
      formattedPath = path.replace('/static/uploads/photos/', '/uploads/photos/');
    } 
    // If it's a partial path like 'photos/booking_id/filename.png'
    else if (path.startsWith('photos/')) {
      formattedPath = `/uploads/${path}`;
    }
    // Ensure path starts with a slash for URL formatting
    else if (!path.startsWith('/')) {
      formattedPath = `/${path}`;
    }
    
    // Use environment variable for base URL if available
    const baseUrl = getEnvVar('REACT_APP_CUSTOMER_SERVICE_URL', 'http://localhost:8087');
    
    // Add cache-busting parameter to prevent browser caching
    return `${baseUrl}${formattedPath}?nocache=${timestamp}`;
  }
};

export default API_CONFIG;
